import {Routes} from '@angular/router';

export const prizeManagementRoutes: Routes = [
  {
    path: 'prizeManagement',
    loadComponent: () => import('./prize-management.component').then(m => m.PrizeManagementComponent),
    children: [
      {
        path: 'prize.lottery',
        loadComponent: () => import('./prize.lottery/prize.lottery.component').then(m => m.PrizeLotteryComponent),
        data: {key: "01JHJF3TAANS4B1P571N4EVZRD", keep: true},
      },
      {
        path: 'prize.mgr',
        loadComponent: () => import('./prize-mgr/prize-mgr.component').then(m => m.PrizeMgrComponent),
        data: {key: "01JJF4BES146ANWKXW4B0JXWXD", keep: true},
      },
      {
        path: 'add.prize.goods',
        loadComponent: () => import('./prize-mgr/add-prize-goods/add-prize-goods.component').then(m => m.AddPrizeGoodsComponent),
        data: {key: "01JJF428S0A1FEMFF07Q3605VW", keep: true},
      },
      {
        path: 'add.prize.goods/:goodsId',
        loadComponent: () => import('./prize-mgr/add-prize-goods/add-prize-goods.component').then(m => m.AddPrizeGoodsComponent),
        data: {key: "01JJG7KG5WZNXMZEG78TCQ19KK", keep: true},
      },
      {
        path: 'lottery.instance',
        loadComponent: () => import('./prize.lottery/lottery.instance/lottery.instance.component').then(m => m.LotteryInstanceComponent),
        data: {key: "01JJG7KG5WZNXMZEG78TCQ19KK", keep: true},
      },
    ]
  },
];
